<template>
    <div>
        <ejs-grid ref="contactGrid" :dataSource="contacts" :allowPaging="true" :allowSorting='true' :sortSettings='sortOptions' :pageSettings='pageSettings' 
                                    :enablePersistence='false' :allowExcelExport='true' :allowReordering='true' :allowResizing='true'>
            <e-columns>
                <e-column field='name' headerText='Contact'  width=20></e-column>
                <e-column field='email' headerText='Email' width=20></e-column>
                <e-column field='phone' headerText='Téléphone' width=20></e-column>
                <e-column field='supplier.name' headerText='Fournisseur' width=20></e-column>
                <e-column field='commands' headerText='' textAlign="center" width=20  :commands="commands"></e-column>
            </e-columns>
        </ejs-grid>

        
        <!-- modal de suppression d'un contact -->
        <modal :show.sync="deleteModal" headerClasses="justify-content-center">
            <h4 slot="header">{{contactName}}</h4>
            <h4 class="text-center mt-0">
                Etes vous sûre de vouloir le <br>
                supprimer?<br>
                (Cette action est définitive et <br>
                irréversible)
            </h4>
            <div class="row justify-content-around">
                <button class="col-5 btn btn-sm btn-primary radius" @click="backToList()">Annuler</button>
                <button class="col-5 btn btn-sm btn-suppr radius" @click="deleteContact()">Supprimer</button>
            </div>
        </modal>
    </div>
</template>
<script>
import { Modal } from 'src/components'
import { GridPlugin, Page, Sort, Search, ExcelExport, Reorder, Resize, CommandColumn} from "@syncfusion/ej2-vue-grids";

    export default {
        name: 'ContactList',
        components:{
            Modal
        },
        data(){ 
            return {
                deleteModal: false,
                contactId: '',
                contactName: '',
                contacts: [],
                
                pageSettings: { pageSizes: [10, 20, 50] , pageSize: 10  },

                sortOptions: { columns: [{ field: 'name', direction: 'Ascending' }] },
                
                commands: [
                    { buttonOption: { cssClass: 'e-flat', iconCss: 'fa fa-edit', click: this.editButton} },
                    { buttonOption: { cssClass: 'e-flat', iconCss: 'fa fa-trash-alt', click: this.deleteButton} },
                ],
            }
        },
        provide: {
            grid: [Page, Sort, Search, ExcelExport, Reorder, Resize, CommandColumn]
        },
        beforeDestroy(){
            // Sauvegarde la configuration du tableau dans le localStorage
            var grid = this.$refs.contactGrid.ej2Instances;
            localStorage.setItem('contactGrid', (grid.getPersistData()));
        },
        mounted() {
            // Remplir "contacts" avec un appel GET Axios
            this.axios.get(process.env.VUE_APP_API_BASE_URL + `fnc/contact/list`).then((response) => {
                this.contacts = response.data
            })

            this.getPersistentSettings('contactGrid')

        },
        methods: {

            backToList() {
                this.deleteModal = false
            },

            getPersistentSettings(ref){
                if(localStorage.getItem(ref) !== null){
                    var grid = this.$refs[ref].ej2Instances;

                    var model = (localStorage.getItem(ref))
                    var modelParsed = JSON.parse(model);

                    var newColumns= [];
                    var cookieColumns = modelParsed.columns;
                    var actualColumns = grid.columns;

                    cookieColumns.forEach(cookieColumn => {
                    actualColumns.forEach(actualColumn => {
                        if(actualColumn.index == cookieColumn.index){
                        actualColumn.visible = cookieColumn.visible;
                        newColumns.push(actualColumn)
                        }
                    })
                    })

                    grid.columns = newColumns;
                    grid.sortSettings = modelParsed.sortSettings;
                    grid.pageSettings.currentPage = modelParsed.pageSettings.currentPage
                }
            },

            editButton(args){
                var rowEle = $(args.target).parents('.e-row')
                var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
                this.$refs.contactGrid.selectRow(rowIndex)
                var rowData = this.$refs.contactGrid.getSelectedRecords()[0]
                this.$router.push({ name: 'contact form', params: { id: rowData.id }})
            },

            deleteButton(args){
                var rowEle = $(args.target).parents('.e-row')
                var rowIndex = parseInt(rowEle[0].getAttribute('aria-rowindex'))
                this.$refs.contactGrid.selectRow(rowIndex)
                var rowData = this.$refs.contactGrid.getSelectedRecords()[0]
                this.contactId = rowData.id
                this.contactName = rowData.name
                this.deleteModal = true
                
            },

            deleteContact(){
                const index = this.contacts.findIndex(contact => contact.id === this.contactId)
                this.axios.post(process.env.VUE_APP_API_BASE_URL + `contact/delete/` + this.contactId).then((response => {
                    this.$notify({ message: 'Le contact à bien été supprimé', type: "success", verticalAlign: "bottom" })
                }))
                this.deleteModal = false     
                this.contacts.splice(index,1)
                this.refreshContactList()  
                
            },

            refreshContactList(){
                this.$refs.contactGrid.refresh()   
            },

            // Permet de faire une recherche dans le tableau
            search: function() {
                let searchText = document.getElementsByClassName('MySearch')[0].value;
                this.$refs.contactGrid.search(searchText);
            },

            excelExport: function() {
                this.$refs.contactGrid.excelExport();
            }
        },
    }
</script>